'use client'

import { useAuthenticatedWalletClient } from '@/hooks/use-authenticated-wallet-client'
import { ArtBlocksClient } from '@artblocks/sdk'
import { env } from 'environments'
import { useSession } from 'next-auth/react'
import * as React from 'react'
import { createContext } from 'react'
import { usePublicClient } from 'wagmi'

const ArtBlocksContext = createContext<ArtBlocksClient>(
  new ArtBlocksClient({
    graphqlEndpoint: env.HASURA_GRAPHQL_ENDPOINT
  })
)

interface ArtblocksProviderProps {
  children: React.ReactNode
}

export function ArtBlocksProvider({ children }: ArtblocksProviderProps): React.ReactElement {
  const { data: session } = useSession()

  const publicClient = usePublicClient({
    chainId: env.chainId
  })

  const jwt = session?.jwt
  const authedWalletClient = useAuthenticatedWalletClient()

  const [abClient, setAbClient] = React.useState<ArtBlocksClient>(
    new ArtBlocksClient({
      graphqlEndpoint: env.HASURA_GRAPHQL_ENDPOINT
    })
  )

  React.useEffect(() => {
    setAbClient(
      new ArtBlocksClient({
        graphqlEndpoint: env.HASURA_GRAPHQL_ENDPOINT,
        // TODO: Figure out how to deal with version differences
        publicClient: publicClient as any,
        walletClient: authedWalletClient as any,
        authToken: jwt
      })
    )
  }, [publicClient, authedWalletClient, jwt])

  return <ArtBlocksContext.Provider value={abClient}>{children}</ArtBlocksContext.Provider>
}

export function useArtBlocksClient(): ArtBlocksClient {
  const context = React.useContext(ArtBlocksContext)

  if (context === undefined) {
    throw new Error('useArtBlocksClient must be used within an ArtBlocksProvider')
  }

  return context
}
